import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import RoutersPage from './pages/RoutersPage';
import HistoryPage from './pages/HistoryPage';
import ClientsPage from './pages/ClientsPage';
import ClientEditPage from './pages/ClientEditPage';
import ClientImportPage from './pages/ClientImportPage';
import Layout from './components/Layout';
import { useAuth } from './context/AuthContext';

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth(); // <-- Obtenemos el estado de carga

    // --- NUEVA LÓGICA DE CARGA ---
    if (loading) {
        // Mientras revisamos si hay token, mostramos un mensaje
        return <div>Cargando sesión...</div>;
    }

    return user ? children : <Navigate to="/login" />;
};

function App() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<DashboardPage />} />
                <Route path="routers" element={<RoutersPage />} />
                <Route path="clients" element={<ClientsPage />} />
                <Route path="clients/import" element={<ClientImportPage />} />
                <Route path="clients/:clientId" element={<ClientEditPage />} />
                <Route path="history" element={<HistoryPage />} />
            </Route>
        </Routes>
    );
}

export default App;